import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import { Box } from "@mui/material";
import Button from "@mui/material/Button";
import SyncIcon from "@mui/icons-material/Sync";
import { useNavigate } from "react-router-dom";

const EditToolbar = () => {
  let navigate = useNavigate();

  function handleRefresh() {
    navigate(0);
  }

  return (
    <Box sx={{ p: 0.5, pb: 0 }}>
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport
          csvOptions={{
            fileName: "SystemLogs",
            delimiter: ";",
            utf8WithBom: true,
          }}
        />
        <GridToolbarQuickFilter />
        <Button color="primary" startIcon={<SyncIcon />} onClick={handleRefresh}>
          Refresh
        </Button>
      </GridToolbarContainer>
    </Box>
  );
};

export default EditToolbar;